import AlertIcon from "./alert_icon";
import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import { REACT_QUERY_KEYS } from "../../enums/react_query_key_enum";
import { fetchSiteData } from "../../scripts/api_v2/site_client";
import { useParams } from "react-router-dom";
import useBackend from "../../hooks/use_backend";

export default function AlertSummary({ device }) {
  const params = useParams();
  const backend = useBackend();
  const [highestAlert, setHighestAlert] = React.useState([]);
  let {
    data: siteData,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [REACT_QUERY_KEYS.SITE_DATA, backend.fetch, params.site_id],
    queryFn: () => fetchSiteData(backend.fetch, params.site_id),
    enabled: false, // sitePage will refresh the query
  });

  React.useEffect(() => {
    const alerts = siteData.alerts.filter((a) => a.device_id == device.device_id);
    var highest = null;

    for (var i = 0; i < alerts.length; ++i) {
      if (highest === null || alerts[i].level > highest.level) {
        highest = alerts[i];
      }
    }
    setHighestAlert(highest);
  }, [siteData]);

  return highestAlert ? (
    <AlertIcon style={{ paddingBottom: 3 }} level={highestAlert.alert_level} icon={highestAlert.icon} />
  ) : null;
}
